import $ from "jquery";


export function triggerSelectResize() {
  // Ensure the select2 has instantiated
  $(document).ready(function() {
    // Target all multi-selects
    $('body').find('.select2-selection--multiple').each(function() {
      selectResize(this);
    });
  });
};

export function selectResize(el) {
  
  // Stop if visible
  if ($(el).is(":visible")) {
    return;
  }
  
  let $self = $(el),
      $inputEl = $self.find('.select2-search__field'),
      $inputLineHeight = $inputEl.css('line-height'),
      $inputFontSize = $inputEl.css('font-size'),
      $inputWidth,
      placeholderText = $inputEl.attr('placeholder'),
      $innerSpanEl = $('<span class="select-copy-placeholder-text"></span>'),
      $targetSelector = $('<div class="select-copy-element" style="z-index:-999999;position: absolute;top:-999999px;left:-999999px;"></div>');

  // Append scratch HTML
  $('body').append($targetSelector);

  // Append span to scratch
  $targetSelector.append($innerSpanEl);
  
  // Apply CSS to new span
  $innerSpanEl.css({
    'font-size': $inputFontSize, 
    'line-height': $inputLineHeight,
  });
  $innerSpanEl.text(placeholderText);
  
  // get span placeholder text width and round it up
  $inputWidth = Math.round($innerSpanEl.outerWidth()) + 5;
  
  // Apply new width to original element
  $inputEl.css('width', $inputWidth);
  
  // remove element
  $targetSelector.remove();
}


// WEBPACK FOOTER //
// ./src/utilities/select2MultiSelectResize/index.js